import { Observable } from 'rxjs';
import Paginate from '../interfaces/paginate';
import PartnerDepartment from '../interfaces/partnerDepartment';

import { HttpClient } from './http-client';

export class PartnerDepartmentService extends HttpClient {
  index(
    farmId: string,
    partnerId: string
  ): Observable<Paginate<PartnerDepartment>> {
    return this.get<Paginate<PartnerDepartment>>(
      `/api/farms/${farmId}/partners/${partnerId}/departments`
    );
  }

  store(
    farmId: string,
    partnerId: string,
    department: PartnerDepartment
  ): Observable<PartnerDepartment> {
    return this.post<PartnerDepartment>(
      `/api/farms/${farmId}/partners/${partnerId}/departments`,
      department
    );
  }

  show(
    farmId: string,
    partnerId: string,
    id: string
  ): Observable<PartnerDepartment> {
    return this.get<PartnerDepartment>(
      `/api/farms/${farmId}/partners/${partnerId}/departments/${id}`
    );
  }

  update(
    farmId: string,
    partnerId: string,
    id: string,
    department: PartnerDepartment
  ): Observable<PartnerDepartment> {
    return this.put<PartnerDepartment>(
      `/api/farms/${farmId}/partners/${partnerId}/departments/${id}`,
      department
    );
  }

  destroy(farmId: string, partnerId: string, id: string) {
    return this.delete(
      `/api/farms/${farmId}/partners/${partnerId}/departments/${id}`
    );
  }
}
